(() => {
  function initGallery(gallery) {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const slides = [...gallery.querySelectorAll('[data-media-id]')];
    const links = [...gallery.querySelectorAll('[data-select-media]')];
    const zoom = gallery.querySelector('[data-zoom]');
    const lightbox = gallery.querySelector('.media-lightbox');
    let current;
    const select = id => {
      const next = slides.find(slide => slide.dataset.mediaId === id) || slides[0];
      if (!next) return;
      slides.forEach(slide => {
        slide.hidden = slide !== next;
        if (slide !== next) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      links.forEach(link => link.setAttribute('aria-current', String(link.dataset.selectMedia === next.dataset.mediaId)));
      current = next;
      zoom.hidden = !next.querySelector('img') || !lightbox.showModal;
    };
    gallery.classList.add('gallery-enhanced');
    select(gallery.dataset.initialMedia);
    links.forEach(link => link.addEventListener('click', event => { event.preventDefault(); select(link.dataset.selectMedia); }));
    gallery.addEventListener('variant:media', event => { if (event.detail) select(event.detail); });
    zoom.addEventListener('click', () => {
      const source = current.querySelector('img');
      if (!source) return;
      const image = lightbox.querySelector('img');
      image.src = source.currentSrc || source.src;
      image.alt = source.alt;
      lightbox.showModal();
      document.documentElement.classList.add('media-dialog-open');
    });
    lightbox.querySelector('[data-close-zoom]').addEventListener('click', () => lightbox.close());
    lightbox.addEventListener('close', () => { document.documentElement.classList.remove('media-dialog-open'); zoom.focus(); });
  }
  document.querySelectorAll('[data-gallery]').forEach(initGallery);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gallery]').forEach(initGallery));
})();
